import { TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody, Button, Box } from "@mui/material";
import 'react-querybuilder/dist/query-builder.css';
import { Link, useLoaderData } from "react-router-dom";
import api from "../../lib/api";
import { RuleSet } from "../../types/ruleSetTypes";
import { useTranslation } from 'react-i18next';
import PageHeader from '../../components/PageHeader';
import EmptyState from '../../components/EmptyState';
import RuleIcon from '@mui/icons-material/Rule';

export async function rulesLoader() {
  return api.get<RuleSet[]>('/v1/rulesets');
}

export default function RuleSets() {
  const { t } = useTranslation();
  const rulesets = useLoaderData() as RuleSet[];

  return (
    <Box sx={{ width: '100%', minWidth: 0 }}>
      <PageHeader title={t('rules.title')} description={t('ui.rulesDescription')} icon={<RuleIcon />} actions={<Button variant="contained" component={Link} to="/rules/create">{t('rules.create')}</Button>} />
      {rulesets.length === 0 ? <Paper variant="outlined"><EmptyState icon={<RuleIcon />} title={t('ui.rulesEmpty')} description={t('ui.rulesEmptyHelp')} action={<Button variant="contained" component={Link} to="/rules/create">{t('rules.create')}</Button>} /></Paper> : <TableContainer component={Paper} variant="outlined">
        <Table aria-label={t('rules.title')}>
          <TableHead>
            <TableRow>
              <TableCell>{t('common.fields.name')}</TableCell>
              <TableCell>{t('common.fields.description')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rulesets.map((ruleset) => (
              <TableRow
                key={ruleset.id}
                hover
                sx={{
                  '&:last-child td, &:last-child th': { border: 0 },
                }}
              >
                <TableCell align="left"><Box component={Link} to={`/rules/${ruleset.id}`} sx={{ color: 'primary.main', fontWeight: 600, display: 'inline-block', py: 0.5, '&:hover': { textDecoration: 'underline' } }}>{ruleset.name}</Box></TableCell>
                <TableCell align="left">{ruleset.description}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>}
    </Box>
  );
};
